// components/ReviewForm.js
import { useState } from "react";
import { apiClient } from "../../services/apiClientService";
import ReactStars from "react-rating-stars-component";

const ReviewForm = ({ productId, orderId, onClose, onSubmitted }) => {
  const showCancel = typeof onClose === "function";
    const [rating, setRating] = useState(5);
    const [comment, setComment] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const submitReview = async () => {
        try {
            if (submitting) return;
            setSubmitting(true);
            await apiClient("POST", "/api/reviews", {
                productId,
                orderId,
                rating,
                comment,
            });
            setSubmitted(true);
            onSubmitted?.();
        } catch (err) {
            alert(err?.message || "Error submitting review.");
        } finally {
            setSubmitting(false);
        }
    };

    return submitted ? (
        <div className="p-4 text-green-700">Thanks! Review submitted.</div>
    ) : (
        <div className="p-4 bg-white rounded shadow">
            <h3 className="font-semibold text-lg mb-2">Leave a Review</h3>
            <div className="mb-2">
                <ReactStars
                    count={5}
                    value={rating}
                    onChange={newRating => setRating(newRating)}
                    size={24}
                    activeColor="#ffd700"
                />
                <label className="block text-sm">Rating</label>
                {/* <select value={rating} onChange={(e) => setRating(+e.target.value)} className="border rounded w-full p-1">
                    {[1, 2, 3, 4, 5].map((r) => (
                        <option key={r} value={r}>{r} Star{r > 1 ? 's' : ''}</option>
                    ))}
                </select> */}
            </div>
            <textarea
                className="border w-full p-2 rounded mb-2"
                rows="3"
                placeholder="Write your feedback..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
            />
            <div className="flex flex-wrap gap-2">
                <button
                    type="button"
                    onClick={submitReview}
                    disabled={submitting}
                    className={`rounded px-4 py-2 text-sm font-semibold text-white ${submitting ? "cursor-not-allowed bg-green-400" : "bg-green-600 hover:bg-green-700"}`}
                >
                    {submitting ? "Submitting..." : "Submit"}
                </button>
                {showCancel ? (
                  <button type="button" onClick={onClose} className="rounded px-4 py-2 text-sm text-gray-600 hover:bg-gray-100">
                    Cancel
                  </button>
                ) : null}
            </div>
        </div>
    );
};

export default ReviewForm;
